module.exports = __webpack_public_path__ + "static/media/loading.3107f96d.gif";